if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
  setTimeout(() => {
    let a = document.querySelector('button[name="checkout"]');
    if (a) {
      a.addEventListener("click", (e) => {
        let oldText = e.target.innerText;
        console.log(e.target);
        e.target.innerText = "loading";
        setTimeout(() => {
          e.target.innerText = oldText;
        }, 1000);
      });
    }

    function addEventCheckout() {
      let buttonQuantity = document.querySelectorAll(".qty-input__btn");
      if (buttonQuantity.length) {
        buttonQuantity.forEach((e) => {
          addEventListener("click", () => {
            setTimeout(() => {
              BSS_B2B.observer.cartSubject.listenCartCheckout();
            }, 1500);
          });
        });
      }
      let inputQuantity = document.querySelector(".qty-input__input");
      if (inputQuantity)
        inputQuantity.addEventListener("change", () => {
          setTimeout(() => {
            BSS_B2B.observer.cartSubject.listenCartCheckout();
          }, 1500);
        });
    }
    addEventCheckout();
  }, 1500);

  window.bssB2BHooks = window.bssB2BHooks || {
    actions: {},
    filters: {},
  };
  window.BSS_B2B = window.BSS_B2B || {};
  window.BSS_B2B.addAction = (tag, callback) => {
    window.bssB2BHooks.actions[tag] = callback;
  };
  window.BSS_B2B.addFilter = (tag, value) => {
    window.bssB2BHooks.filters[tag] = value;
  };
  let handleFixQV;
  const detectQV = ({ productSubject }) => {
    handleFixQV = (e) => {
      productSubject.notifyObserver("VariantChange", "VariantClickChange", {
        event: e,
        productForm: document
          .querySelector("quick-add-drawer[bss-b2b-main-product-form]")
          .getAttribute("bss-b2b-product-form-id"),
      });
    };
  };
  window.BSS_B2B.addAction("detect:product/lazy_load", detectQV);
  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".js-quick-add").forEach((target) => {
      target.addEventListener("click", (e) => {
        const jobId = setInterval(() => {
          const qvElement = document.querySelector(
            "[bss-b2b-main-product-form] .product-info__price"
          );
          if (qvElement) {
            window.dispatchEvent(new Event("bss_b2b:CustomInitProductSubject"));
            setTimeout(() => {
              document
                .querySelector("#product-form-quickadd input[name='id']")
                .dispatchEvent(new Event("change", { bubbles: true }));
              // handleFixQV(e);
            }, 100);
            clearInterval(jobId);
          }
        }, 500);
        setTimeout(() => {
          clearInterval(jobId);
        }, 7000);
      });
    });
  });
}
